var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "button-edit py-2 px-4"
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "items": _vm.socials,
      "item-text": "name",
      "item-value": "key",
      "label": _vm.$t('socialedit_social_media_website')
    },
    model: {
      value: _vm.form.icon,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "icon", $$v);
      },
      expression: "form.icon"
    }
  }), _c('v-text-field', {
    staticClass: "pt-5",
    attrs: {
      "hide-details": "",
      "placeholder": _vm.$t('socialedit_display_text'),
      "label": _vm.$t('socialedit_display_text')
    },
    model: {
      value: _vm.form.content,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "content", $$v);
      },
      expression: "form.content"
    }
  }), _c('rich-text-input', {
    attrs: {
      "placeholder": _vm.$t('socialedit_link_placeholder'),
      "content": _vm.form.url,
      "mode": "url",
      "json": _vm.editorContentJson,
      "label": _vm.$t('socialedit_link')
    },
    on: {
      "update:content": function updateContent($event) {
        return _vm.$set(_vm.form, "url", $event);
      },
      "update:json": function updateJson($event) {
        _vm.editorContentJson = $event;
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }